// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={61}
    height={61}
    viewBox="0 0 61 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.8499 36.7131L22.7231 52.2096L32.0918 43.3343L57.7197 8.84497L18.8499 36.7131Z"
      fill="#29A9FF"
      stroke="#29292F"
      strokeWidth={0.635417}
      strokeLinejoin="bevel"
    />
    <path
      d="M57.7198 8.84497L3.35413 28.9649L18.85 36.7131L57.7198 8.84497Z"
      fill="#ABE3FF"
      stroke="#29292F"
      strokeWidth={0.635417}
      strokeLinejoin="bevel"
    />
    <path
      d="M57.72 8.84497L42.094 48.3361L26.5981 40.5879L57.72 8.84497Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.635417}
      strokeLinejoin="bevel"
    />
    <path
      d="M32.0903 43.3344L22.7244 52.2097L26.5977 40.588L32.0903 43.3344Z"
      fill="#005DE5"
      stroke="#29292F"
      strokeWidth={0.635417}
      strokeLinejoin="bevel"
    />
  </svg>
);
const SvgPaperPlane = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgPaperPlane;
